<template>
  <div
    class="accruals-estimates-loader"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading accruals table"
    data-testid="accruals-estimates-page__skeleton-loader"
  >
    <div class="accruals-estimates-loader__head">
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--check" />
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--vendor" />
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--location" />
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--amount" />
    </div>
    <div
      v-for="index in rowCount"
      :key="`row-${index}`"
      class="accruals-estimates-loader__row"
    >
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--check" />
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--vendor" />
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--location" />
      <span class="accruals-estimates-loader__bone accruals-estimates-loader__bone--amount" />
    </div>
  </div>
</template>

<script>
const ROW_HEIGHT_FALLBACK = 48;

export default {
  name: 'AccrualsEstimatesLoader',
  data() {
    return {
      rowCount: 6,
      resizeObserver: null,
    };
  },
  mounted() {
    this.measureRows();
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.measureRows());
      this.resizeObserver.observe(this.$el);
      return;
    }
    window.addEventListener('resize', this.measureRows);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    window.removeEventListener('resize', this.measureRows);
  },
  methods: {
    measureRows() {
      const root = this.$el;
      if (!root || !root.clientHeight) return;
      const head = root.querySelector('.accruals-estimates-loader__head');
      const row = root.querySelector('.accruals-estimates-loader__row');
      const headHeight = head ? head.getBoundingClientRect().height : ROW_HEIGHT_FALLBACK;
      const rowHeight = row ? row.getBoundingClientRect().height : ROW_HEIGHT_FALLBACK;
      if (!rowHeight) return;
      const next = Math.max(1, Math.ceil((root.clientHeight - headHeight) / rowHeight));
      if (next !== this.rowCount) this.rowCount = next;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimatesLoader.scss';
</style>
